export const renderFeatureValue = isAvailable => {
  if (typeof isAvailable === 'boolean') {
    return isAvailable ? '✓' : '✕'
  }
  return isAvailable
}
